import { store } from '../../../store';
import { activateEditMode } from '../../../store/conversation/conversation.slice';

export const handleActivateEditMode = (question) => {
  store.dispatch(activateEditMode(question));
};
